import { inject, Injectable } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ValidatorFn,
  FormControl,
} from '@angular/forms';
import { ITimelineDocumentoForm } from '../interface/dinamic-form.interface';

@Injectable({
  providedIn: 'root',
})
export class FormBuilderService {
  private fb = inject(FormBuilder);

  private form!: FormGroup<ITimelineDocumentoForm>;

  buildForm(): FormGroup<ITimelineDocumentoForm> {
    this.form = this.fb.group<ITimelineDocumentoForm>({
      IdfdArchivo: this.createControl<number | null>(null),
      CodfdCabecera: this.createControl<number | null>(null),
      idPaqueteConcatenadotmp: this.createControl<string | null>(null),
      CodfdDocPermitidos: this.createControl<string | null>(null),
      FechaRegistro: this.createControl<string | null>(null),
      cmpoObservacion: this.createControl<string | null>(null),
      cmpoCodigoUnico: this.createControl<string | null>(null),
      strcmpoValor: this.createControl<string | null>(null),
      cmpoCodProveedor: this.createControl<string | null>(null),
    });

    return this.form;
  }

  /**
   *
   * @param value
   * @param validators
   * @returns
   * @augments OJO => No modificar
   */

  private createControl<T>(
    value: T | null,
    validators?: ValidatorFn | ValidatorFn[] | null
  ): FormControl<T | null> {
    return this.fb.nonNullable.control(value, validators);
  }

  //#region GET GRUPO FORM Ejemplo para obtener los grupos del formulario cuando se neceiten
  get datosBasicosFormGroup() {
    return this.form.get('filesBytesRequest');
  }

  //#endregion
}
